import { NgModule } from "@angular/core";
import {
  provideRouter,
  RouterModule,
  withViewTransitions,
} from "@angular/router";
import { applicationPillar3aRoutes } from "./application/pillar-3a/routes/application.routes";
import { applicationTermLifeInsuranceRoutes } from "./application/term-life-insurance/routes/application.routes";
import { quotePillar3aRoutes } from "./quote/pillar-3a/routes/quote.routes";
import { quoteTermLifeInsuranceRoutes } from "./quote/term-life-insurance/routes/quote.routes";
import { topLevelRoutes } from "./shared/routes/root/root.routes";
import { CustomRoute } from "./shared/routes/shared/shared-route.constant";

export const termLifeInsuranceRoutes: CustomRoute[] = [
  // Quotes
  ...quoteTermLifeInsuranceRoutes,
  // Application
  ...applicationTermLifeInsuranceRoutes,
];

export const pillar3aRoutes: CustomRoute[] = [
  // Quotes
  ...quotePillar3aRoutes,
  // Application
  ...applicationPillar3aRoutes,
];

export const routes: CustomRoute[] = [
  ...topLevelRoutes,
  ...termLifeInsuranceRoutes,
  ...pillar3aRoutes,
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  providers: [provideRouter(routes, withViewTransitions())],
  exports: [RouterModule],
})
export class AppRoutingModule {}
